"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Button = require("./form/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = function (_Component) {
  (0, _inherits3.default)(Hero, _Component);

  function Hero() {
    (0, _classCallCheck3.default)(this, Hero);
    return (0, _possibleConstructorReturn3.default)(this, (Hero.__proto__ || (0, _getPrototypeOf2.default)(Hero)).apply(this, arguments));
  }

  (0, _createClass3.default)(Hero, [{
    key: "handleClick",
    value: function handleClick(route) {
      var _this2 = this;

      return function () {
        _this2.props.pushRoute(route);
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container hero" },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "hero-top" },
            _react2.default.createElement(
              "div",
              { className: "hero-logo" },
              _react2.default.createElement("img", { src: "/img/maaporssi-white-green-tip.png" }),
              _react2.default.createElement(
                "a",
                { href: "https://sitowise.com" },
                _react2.default.createElement("img", { src: "/img/sitowise-logo-green.png" })
              )
            ),
            _react2.default.createElement("div", { className: "hero-divider" }),
            _react2.default.createElement(
              "div",
              { className: "hero-description" },
              "Valitsemalla Maap\xF6rssin varmistat maa-ainesten nykyaikaisen kierr\xE4tyksen. Avullamme tarjoat ja vastaanotat puhtaat ylij\xE4\xE4m\xE4maa-ainekset ja purkumateriaalit niin yksityisiin kuin ammattimaisiin maarakennustarpeisiin - ymp\xE4ri vuoden ja vuorokauden. Kauttamme saat my\xF6s korkealaatuiset infra-, maa- ja viherrakentamisen tuotteet.",
              _react2.default.createElement("br", null),
              _react2.default.createElement("br", null),
              "Maap\xF6rssi on nyt osa Sitowise\xE4. Asiantuntijamme opastavat ty\xF6maasi ylij\xE4\xE4m\xE4maa-ainesten kierr\xE4tt\xE4misess\xE4; huolellisesti toteutettu maa-aineskiertotalous on kest\xE4v\xE4 vaihtoehto, joka korvaa luonnosta kaivetut maa-ainekset ja on l\xE4ht\xF6kohtaisesti taloudellisempi sek\xE4 ymp\xE4rist\xF6yst\xE4v\xE4llisempi vaihtoehto."
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "hero-testimonials-container" },
            _react2.default.createElement(
              "div",
              { className: "hero-testimonials" },
              _react2.default.createElement(
                "a",
                {
                  href: "https://www.trustmary.com/review/75dLpYU-d",
                  "data-trustmary-embed": "L7BVbwa76"
                },
                "Trustmary Reviews"
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "hero-buttons" },
            _react2.default.createElement(
              "div",
              { className: "hero-button-left" },
              _react2.default.createElement(_Button2.default, {
                text: "Ilmoita ilmaiseksi",
                additionalClasses: "button-inverse",
                onClick: this.handleClick("/jata-ilmoitus")
              })
            ),
            _react2.default.createElement(
              "div",
              { className: "hero-button-right" },
              _react2.default.createElement(_Button2.default, {
                text: "Osta lipukkeita",
                onClick: this.handleClick("/lipukekauppa")
              })
            )
          )
        )
      );
    }
  }]);
  return Hero;
}(_react.Component);

exports.default = Hero;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Hero.js
 ** module id = 1145
 ** module chunks = 0
 **/